import React from 'react';
import PropTypes from 'prop-types';
import './ToggleItem.css';

/**
 * ToggleItem - Eine Apple-Style Switch Komponente für Export-Optionen.
 * 
 * @param {Object} props
 * @param {string} props.label - Der Text neben dem Switch
 * @param {boolean} props.value - Der aktuelle Zustand
 * @param {Function} props.onChange - Callback beim Umschalten
 * @param {string} props.icon - Optionales Icon
 */
const ToggleItem = ({ label, value, onChange, icon }) => {
    return (
        <div className="export-toggle-item" onClick={() => onChange()}>
            <div className="export-toggle-label">
                {icon && <span className="export-toggle-icon">{icon}</span>}
                {label}
            </div>
            <div className={`export-switch ${value ? 'active' : ''}`}>
                <div className="export-switch-handle" />
            </div>
        </div>
    );
};

ToggleItem.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    icon: PropTypes.string
};

export default ToggleItem;
